import CustomDropdown from '../CustomDropdown/CustomDropdown';
import { District } from '../../../../peekapak-types/ReportDataExchangeTypes';
import styles from './DistrictSelector.module.scss';

interface Props {
  currentlySelectedDistrict: string;
  districtsList: District[];
  initialValue: string;
  isPeekapakAdmin: boolean;
  onSelectDistrict: (arg0: string | null) => void;
  disableChangeLocation: boolean;
}

const DistrictSelector = ({
  currentlySelectedDistrict,
  districtsList,
  initialValue,
  isPeekapakAdmin,
  onSelectDistrict,
  disableChangeLocation,
}: Props) => {
  if (!isPeekapakAdmin) return null;
  return (
    <div className={styles.districtSelectorContainer}>
      <CustomDropdown
        list={districtsList}
        onSelectSubject={onSelectDistrict}
        initialValue={initialValue}
        currentlySelectedItem={currentlySelectedDistrict}
        disableChangeLocation={disableChangeLocation}
        icon={'ion:school-outline'}
      />
    </div>
  );
};

export default DistrictSelector;
